import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-nexus-loader',
  templateUrl: './nexus-loader.component.html',
  styleUrls: ['./nexus-loader.component.scss']
})
export class NexusLoaderComponent implements OnInit {
  @Input() showLoader: boolean = true;
  @Input() autoHide: boolean = true;
  @Input() duration: number = 3500; 
  @Input() fadeOutDuration: number = 500; 
  @Output() animationComplete = new EventEmitter<void>();

  isFadingOut = false;

  constructor() { }

  ngOnInit(): void {
    if (this.autoHide) {
      this.startAutoHideTimer();
    }
  }

  private startAutoHideTimer(): void {
    setTimeout(() => {
      this.isFadingOut = true;
      setTimeout(() => this.hideLoader(), this.fadeOutDuration);
    }, this.duration);
  }

  hideLoader(): void {
    this.showLoader = false;
    this.animationComplete.emit();
  }
}
